
// Dependencies
import { Page } from "@/assets/scripts/Page/Page";
import { defineComponent, PropType } from "vue";
// Components
import PageEditorSection from "./PageEditorSection.vue";

export default defineComponent({
  name: "PageEditor",
  props: {
    page: {
      type: Object as PropType<Page>,
      required: true
    }
  },
  emits: ["execute"],
  components: { PageEditorSection }
});
